import { useFiltersV2Actions } from "PFApp/components/filters_v2";
import { FiltersV2ResetAllButton } from "PFApp/components/filters_v2/components/filters_v2_reset_all_button";
import {
  PreviewFiltersV2Args,
  usePreviewFiltersV2
} from "PFApp/components/filters_v2/parts/filters_v2_preview/hooks/use_preview_filters_v2";
import { FilterV2PreviewItem } from "PFApp/components/filters_v2/parts/filters_v2_preview/parts/filter_v2_preview_item";
import { FiltersV2ContainerWithShowMore } from "PFApp/components/filters_v2/parts/filters_v2_preview/parts/filters_v2_container_with_show_more";
import { FilterV2ComponentLabels } from "PFApp/components/filters_v2/types";
import { Inline } from "PFComponents/containers";
import { Typography } from "PFComponents/typography";
import { KnownFiltersV2 } from "PFTypes/filters_v2";
import { useTranslation } from "react-i18next";

import css from "./filters_v2_preview.module.scss";

type FiltersV2PreviewProps = PreviewFiltersV2Args & { labels?: FilterV2ComponentLabels; disabled?: boolean };

export const FiltersV2Preview = ({
  omit = [KnownFiltersV2.Term],
  forceVisible,
  disabled,
  labels
}: FiltersV2PreviewProps) => {
  const { t } = useTranslation("filters", { keyPrefix: "preview" });
  const { resetValues } = useFiltersV2Actions();

  const filtersToPreview = usePreviewFiltersV2({ omit, forceVisible });

  if (filtersToPreview.length === 0) {
    return null;
  }

  return (
    <Inline alignItems="center" className={css.filtersPreview}>
      <Typography variant="bodyRegular">{t("header")}</Typography>
      {!disabled && (
        <div>
          <FiltersV2ResetAllButton onReset={resetValues} />
        </div>
      )}
      <div className={css.filterPreviewItemsWrapper} data-qa-id="FiltersPreviewItemsWrapper">
        <FiltersV2ContainerWithShowMore disabled={disabled}>
          {filtersToPreview.map((filter) => (
            <FilterV2PreviewItem
              disabled={disabled}
              key={`${filter.name}(${filter.isChildren ? "children" : "main"})`}
              filter={filter}
              labels={labels}
            />
          ))}
        </FiltersV2ContainerWithShowMore>
      </div>
    </Inline>
  );
};
